'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LeftMenu$ExternalLink(url, label) {
  this.Kh = null;
  this.Kg = null;
  this.Kh = url;
  this.Kg = label;
}
export { $c_Lpresto_LeftMenu$ExternalLink as $c_Lpresto_LeftMenu$ExternalLink };
$p = $c_Lpresto_LeftMenu$ExternalLink.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LeftMenu$ExternalLink;
/** @constructor */
function $h_Lpresto_LeftMenu$ExternalLink() {
}
export { $h_Lpresto_LeftMenu$ExternalLink as $h_Lpresto_LeftMenu$ExternalLink };
$h_Lpresto_LeftMenu$ExternalLink.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_LeftMenu$ExternalLink) && ((this.Kh === x$0.Kh) && (this.Kg === x$0.Kg))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ExternalLink";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Kh;
  }
  if ((n === 1)) {
    return this.Kg;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_LeftMenu$ExternalLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iA)));
}
export { $isArrayOf_Lpresto_LeftMenu$ExternalLink as $isArrayOf_Lpresto_LeftMenu$ExternalLink };
var $d_Lpresto_LeftMenu$ExternalLink = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LeftMenu$ExternalLink, "presto.LeftMenu$ExternalLink", ({
  iA: 1,
  iC: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_LeftMenu$ExternalLink as $d_Lpresto_LeftMenu$ExternalLink };
//# sourceMappingURL=presto.-Left-Menu$-External-Link.js.map
